export const constants = {
  defaultCategory: 'Marketing/Community/Content',
} as const;
